import { Context } from "@nuxt/types/app";

import getCapitalize from "./formatting.capitalize.plugin";
import getConvertCurrency from "./formatting.convertCurrency.plugin";
import getConvertToAMPM from "./formatting.convertToAMPM.plugin";
import getCurrencyFilterRp from "./formatting.currencyFilterRp.plugin";
import getDecimalFormat from "./formatting.decimalFormat.plugin";
import getGetCurrencyByCountry from "./formatting.getCurrencyByCountry.plugin";
import getGetFormattedValue from "./formatting.getFormattedValue.plugin";
import getGetUnformattedValue from "./formatting.getUnformattedValue.plugin";
import getIsEmail from "./formatting.isEmail.plugin";
import getIsJSONParsable from "./formatting.isJSONParsable.plugin";
import getIsNumberOnly from "./formatting.isNumberOnly.plugin";
import getIsNumberOnlyEvent from "./formatting.isNumberOnlyEvent.plugin";
import getIsPhone from "./formatting.isPhone.plugin";
import getMaxShowText from "./formatting.maxShowText.plugin";
import getNumberToPriceFormat from "./formatting.numberToPriceFormat.plugin";
import getPriceFormatToNumber from "./formatting.priceFormatToNumber.plugin";
import getReplaceStrVar from "./formatting.replaceStrVar.plugin";
import getShortenWords from "./formatting.shortenWords.plugin";
import getSumOfArray from "./formatting.sumOfArray.plugin";
import getToFirstLettersUppercase from "./formatting.toFirstLettersUppercase.plugin";
import getTransformResponseMessage from "./formatting.transformResponseMessage.plugin";
import getUrlBuilder from "./formatting.urlBuilder.plugin";

export function formattingPlugin(context: Context) {
  const { isNumberOnly } = getIsNumberOnly(context);
  const { decimalFormat } = getDecimalFormat(context);
  const { convertCurrency } = getConvertCurrency();
  const { capitalize } = getCapitalize(context);
  const { priceFormatToNumber } = getPriceFormatToNumber(context);
  const { numberToPriceFormat } = getNumberToPriceFormat(context);
  const { currencyFilterRp } = getCurrencyFilterRp(context);
  const { isPhone } = getIsPhone(context);
  const { isNumberOnlyEvent } = getIsNumberOnlyEvent(context);
  const { sumOfArray } = getSumOfArray(context);
  const { convertToAMPM } = getConvertToAMPM(context);
  const { getCurrencyByCountry } = getGetCurrencyByCountry(context);
  const { getFormattedValue } = getGetFormattedValue(context);
  const { getUnformattedValue } = getGetUnformattedValue(context);
  const { maxShowText } = getMaxShowText(context);
  const { toFirstLettersUppercase } = getToFirstLettersUppercase(context);
  const { shortenWords } = getShortenWords(context);
  const { replaceStrVar } = getReplaceStrVar(context);
  const { isJSONParsable } = getIsJSONParsable(context);
  const { transformResponseMessage } = getTransformResponseMessage(context);
  const { urlBuilder } = getUrlBuilder(context);
  const { isEmail } = getIsEmail(context);

  return {
    isNumberOnly,
    decimalFormat,
    convertCurrency,
    capitalize,
    priceFormatToNumber,
    numberToPriceFormat,
    currencyFilterRp,
    isPhone,
    isNumberOnlyEvent,
    sumOfArray,
    convertToAMPM,
    getCurrencyByCountry,
    getFormattedValue,
    getUnformattedValue,
    maxShowText,
    toFirstLettersUppercase,
    shortenWords,
    replaceStrVar,
    isJSONParsable,
    transformResponseMessage,
    urlBuilder,
    isEmail,
  };
}
